import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { actions } from '../../actions/actionsWrapper';
import { eLoaiSucKhoeActionTypeIds, ILoaiSucKhoeActionTypes } from '../../action-types/danh-muc/ILoaiSucKhoeActionTypes';
import { dm_loaisuckhoe } from '../../../models/response/category/dm_loaisuckhoe';


export function* loaiSucKhoeSaga(): any {
    yield takeLatest(eLoaiSucKhoeActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eLoaiSucKhoeActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eLoaiSucKhoeActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.sucKhoe.loaiSucKhoe.select_all)
    if (res.is_success) {
        yield put(actions.sucKhoe.loaiSucKhoe.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.sucKhoe.loaiSucKhoe.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: ILoaiSucKhoeActionTypes): any {
    const payload: dm_loaisuckhoe = action.payload as dm_loaisuckhoe;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.sucKhoe.loaiSucKhoe.update, payload)
    } else {
        res = yield call(apiWrapper.sucKhoe.loaiSucKhoe.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.sucKhoe.loaiSucKhoe.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.sucKhoe.loaiSucKhoe.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: ILoaiSucKhoeActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.sucKhoe.loaiSucKhoe.delete, payload)
    if (res.is_success) {
        yield put(actions.sucKhoe.loaiSucKhoe.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.sucKhoe.loaiSucKhoe.DELETE_ERROR(res.message ?? "Error"))
    }
}
